import { useState } from 'react'
import { useBrandColors } from '../../hooks/useBrandColors'

export default function Onboarding() {
  const { accent, accentLight, accentBg } = useBrandColors()
  const [step, setStep] = useState(0)
  const [signed, setSigned] = useState(false)
  const [sigName, setSigName] = useState('')
  const [module2done, setModule2done] = useState(false)
  const [quizAnswered, setQuizAnswered] = useState(null)

  const [personalInfo, setPersonalInfo] = useState({
    firstName:'Jamie', lastName:'Mitchell', phone:'', address:'', city:'', state:'ME', zip:'', emergencyName:'', emergencyPhone:'', emergencyRelation:''
  })
  const [w4, setW4] = useState({
    filingStatus:'Single', multipleJobs:false, dependents:'0', otherIncome:'', deductions:'', extraWithholding:''
  })
  const [i9, setI9] = useState({
    citizenStatus:'citizen', docType:'passport', docNumber:'', docExpiry:'', lastName:'Mitchell', firstName:'Jamie', dob:'', ssn:''
  })
  const [directDeposit, setDirectDeposit] = useState({
    bankName:'', routingNumber:'', accountNumber:'', accountType:'checking', split:false, splitAmount:'', split2Bank:'', split2Routing:'', split2Account:''
  })
  const [handbookSig, setHandbookSig] = useState('')
  const [handbookSigned, setHandbookSigned] = useState(false)
  const [policyAcks, setPolicyAcks] = useState({ attendance:false, pto:false, conduct:false, safety:false, data:false })

  const steps = [
    { title:'Welcome',         desc:'Overview & checklist',          icon:'👋' },
    { title:'Personal Info',   desc:'Your details & emergency contact', icon:'👤' },
    { title:'W-4',             desc:'Federal tax withholding',        icon:'🏛️' },
    { title:'I-9',             desc:'Employment eligibility',         icon:'📋' },
    { title:'Direct Deposit',  desc:'Payroll setup',                  icon:'🏦' },
    { title:'Handbook',        desc:'Read & e-sign',                  icon:'📖' },
    { title:'Policies',        desc:'Acknowledge company policies',   icon:'✅' },
    { title:'Complete',        desc:'All done!',                      icon:'🎉' },
  ]

  const totalSteps = steps.length - 1
  const pct = Math.round((step / totalSteps) * 100)

  function handleNext() {
    if (step === 1) {
      if (!personalInfo.firstName || !personalInfo.lastName) { alert('Please enter your name.'); return }
    }
    if (step === 4) {
      if (!directDeposit.bankName || !directDeposit.routingNumber || !directDeposit.accountNumber) { alert('Please complete all required bank fields.'); return }
    }
    if (step === 5) {
      if (!handbookSig.trim()) { alert('Please type your full name to sign the handbook.'); return }
      setHandbookSigned(true)
    }
    if (step === 6) {
      const allAcked = Object.values(policyAcks).every(v => v)
      if (!allAcked) { alert('Please acknowledge all policies to continue.'); return }
    }
    if (step < totalSteps) setStep(s => s + 1)
  }

  const inputStyle = { width:'100%', padding:'9px 13px', border:'1px solid #EDE6DA', borderRadius:6, fontSize:12, fontFamily:"'Montserrat',sans-serif", outline:'none', color:'#2B2B2B', boxSizing:'border-box' }
  const labelStyle = { display:'block', fontSize:9, textTransform:'uppercase', letterSpacing:'0.1em', color:'#6B7D6B', fontWeight:600, marginBottom:5 }
  const sectionHead = (title) => (
    <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'0.12em',color:'#6B7D6B',fontWeight:600,marginBottom:12,paddingBottom:6,borderBottom:'1px solid #EDE6DA'}}>{title}</div>
  )

  return (
    <div style={{fontFamily:"'Montserrat',sans-serif"}}>
      <div style={{marginBottom:20,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div>
          <h1 style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:'#2B2B2B',fontWeight:600}}>Employee Onboarding</h1>
          <p style={{fontSize:11,color:'#6B7D6B',marginTop:2}}>Complete all steps to finish your setup</p>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:10}}>
          <span style={{fontSize:11,color:'#6B7D6B'}}>Progress</span>
          <div style={{width:120,height:6,background:'#EDE6DA',borderRadius:3,overflow:'hidden'}}>
            <div style={{height:'100%',width:pct+'%',background:accent,borderRadius:3,transition:'width 0.4s'}}></div>
          </div>
          <span style={{fontSize:11,fontWeight:600,color:accent}}>{pct}%</span>
        </div>
      </div>

      <div style={{display:'grid',gridTemplateColumns:'220px 1fr',gap:16}}>

        {/* Steps panel */}
        <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden',alignSelf:'start'}}>
          {steps.map((s,i) => (
            <div key={i} onClick={()=>i<=step&&setStep(i)}
              style={{display:'flex',alignItems:'flex-start',gap:10,padding:'11px 14px',borderBottom:'1px solid #EDE6DA',cursor:i<=step?'pointer':'default',background:i===step?accentBg:'#fff',borderLeft:i===step?`3px solid ${accent}`:'3px solid transparent'}}>
              <div style={{width:24,height:24,borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:10,fontWeight:700,flexShrink:0,background:i<step?'#4A7C59':i===step?accent:'#fff',border:i<step||i===step?'none':'1.5px solid #D9C3A3',color:i<=step?'#fff':'#6B7D6B',marginTop:1}}>
                {i < step
                  ? <svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M2 5.5l2.5 2.5L9 3" stroke="#fff" strokeWidth="1.5" strokeLinecap="round"/></svg>
                  : i + 1}
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:11,fontWeight:600,color:i===step?accent:i<step?'#4A7C59':'#4A4A4A'}}>{s.title}</div>
                <div style={{fontSize:10,color:'#8A9E8A',marginTop:1}}>{s.desc}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Work area */}
        <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden',display:'flex',flexDirection:'column'}}>
          <div style={{padding:'14px 20px',borderBottom:'1px solid #EDE6DA',display:'flex',alignItems:'center',gap:10}}>
            <span style={{fontSize:18}}>{steps[step]?.icon}</span>
            <div style={{fontFamily:'Georgia,serif',fontSize:'1.1rem',color:'#2B2B2B',fontWeight:600}}>{steps[step]?.title}</div>
            <span style={{marginLeft:'auto',fontSize:10,color:'#8A9E8A'}}>Step {step+1} of {steps.length}</span>
          </div>

          <div style={{flex:1,padding:'20px',overflowY:'auto',maxHeight:520}}>

            {/* STEP 0 - Welcome */}
            {step === 0 && (
              <div>
                <div style={{textAlign:'center',marginBottom:24}}>
                  <div style={{width:56,height:56,borderRadius:'50%',background:accentBg,border:`2px solid ${accent}`,display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 12px',fontSize:22}}>👋</div>
                  <h2 style={{fontFamily:'Georgia,serif',fontSize:'1.3rem',color:'#2B2B2B',marginBottom:8}}>Welcome, Jamie!</h2>
                  <p style={{fontSize:13,color:'#6B7D6B',lineHeight:1.7,maxWidth:420,margin:'0 auto'}}>We are so glad to have you on the team. This onboarding will guide you through all required paperwork and setup steps. It should take about 10-15 minutes.</p>
                </div>
                <div style={{background:'#F7F2EB',borderRadius:8,padding:'16px',marginBottom:16}}>
                  <div style={{fontSize:11,fontWeight:600,color:'#2B2B2B',marginBottom:12,textTransform:'uppercase',letterSpacing:'0.08em'}}>Your Onboarding Checklist</div>
                  {[
                    {label:'Personal information & emergency contact', step:2},
                    {label:'W-4 Federal Tax Withholding Form', step:3},
                    {label:'I-9 Employment Eligibility Verification', step:4},
                    {label:'Direct Deposit Authorization', step:5},
                    {label:'Employee Handbook - read & sign', step:6},
                    {label:'Company Policy Acknowledgments', step:7},
                  ].map((item,i) => (
                    <div key={i} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 0',borderBottom:'1px solid #EDE6DA'}}>
                      <div style={{width:18,height:18,borderRadius:4,border:'1.5px solid #D9C3A3',background:'#fff',flexShrink:0}}></div>
                      <span style={{flex:1,fontSize:12,color:'#4A4A4A'}}>{item.label}</span>
                      <span style={{fontSize:10,padding:'1px 6px',borderRadius:8,fontWeight:600,background:accentBg,color:accent}}>Step {item.step}</span>
                    </div>
                  ))}
                </div>
                <div style={{padding:'12px 14px',background:'rgba(74,124,89,0.06)',border:'1px solid rgba(74,124,89,0.2)',borderRadius:8,fontSize:12,color:'#4A7C59'}}>
                  Your information is securely stored and only accessible to HR. If you have questions at any point, contact HR at info@gallaghercollectiveworks.com.
                </div>
              </div>
            )}

            {/* STEP 1 - Personal Info */}
            {step === 1 && (
              <div style={{display:'flex',flexDirection:'column',gap:16}}>
                {sectionHead('Basic Information')}
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                  {[['First Name','firstName'],['Last Name','lastName'],['Phone Number','phone'],['Date of Birth','dob']].map(([label,key])=>(
                    <div key={key}>
                      <label style={labelStyle}>{label}</label>
                      <input value={personalInfo[key]||''} onChange={e=>setPersonalInfo(p=>({...p,[key]:e.target.value}))} style={inputStyle}/>
                    </div>
                  ))}
                  <div style={{gridColumn:'1/-1'}}>
                    <label style={labelStyle}>Street Address</label>
                    <input value={personalInfo.address} onChange={e=>setPersonalInfo(p=>({...p,address:e.target.value}))} placeholder="123 Main St" style={inputStyle}/>
                  </div>
                  <div>
                    <label style={labelStyle}>City</label>
                    <input value={personalInfo.city} onChange={e=>setPersonalInfo(p=>({...p,city:e.target.value}))} style={inputStyle}/>
                  </div>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
                    <div>
                      <label style={labelStyle}>State</label>
                      <input value={personalInfo.state} onChange={e=>setPersonalInfo(p=>({...p,state:e.target.value}))} style={inputStyle}/>
                    </div>
                    <div>
                      <label style={labelStyle}>ZIP</label>
                      <input value={personalInfo.zip} onChange={e=>setPersonalInfo(p=>({...p,zip:e.target.value}))} style={inputStyle}/>
                    </div>
                  </div>
                </div>
                {sectionHead('Emergency Contact')}
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                  {[['Full Name','emergencyName'],['Phone Number','emergencyPhone'],['Relationship','emergencyRelation']].map(([label,key])=>(
                    <div key={key}>
                      <label style={labelStyle}>{label}</label>
                      <input value={personalInfo[key]||''} onChange={e=>setPersonalInfo(p=>({...p,[key]:e.target.value}))} style={inputStyle}/>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* STEP 2 - W-4 */}
            {step === 2 && (
              <div style={{display:'flex',flexDirection:'column',gap:16}}>
                <div style={{padding:'10px 14px',background:'rgba(74,107,138,0.06)',border:'1px solid rgba(74,107,138,0.15)',borderRadius:8,fontSize:12,color:'#4A6B8A'}}>
                  This is a simplified W-4 form. Your selections determine how much federal income tax is withheld from your paycheck. When in doubt, select Single and 0 allowances.
                </div>
                {sectionHead('Filing Status')}
                <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:8}}>
                  {['Single','Married Filing Jointly','Head of Household'].map(status=>(
                    <button key={status} onClick={()=>setW4(w=>({...w,filingStatus:status}))}
                      style={{padding:'10px 8px',border:`2px solid ${w4.filingStatus===status?accent:'#EDE6DA'}`,borderRadius:8,background:w4.filingStatus===status?accentBg:'#fff',color:w4.filingStatus===status?accent:'#4A4A4A',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",textAlign:'center'}}>
                      {status}
                    </button>
                  ))}
                </div>
                {sectionHead('Withholding Adjustments')}
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                  <div>
                    <label style={labelStyle}>Dependent Tax Credits ($)</label>
                    <input value={w4.dependents} onChange={e=>setW4(w=>({...w,dependents:e.target.value}))} placeholder="0" style={inputStyle}/>
                    <div style={{fontSize:10,color:'#8A9E8A',marginTop:4}}>Total amount from Step 3 of IRS W-4</div>
                  </div>
                  <div>
                    <label style={labelStyle}>Other Income ($)</label>
                    <input value={w4.otherIncome} onChange={e=>setW4(w=>({...w,otherIncome:e.target.value}))} placeholder="0" style={inputStyle}/>
                    <div style={{fontSize:10,color:'#8A9E8A',marginTop:4}}>Non-job income (interest, dividends)</div>
                  </div>
                  <div>
                    <label style={labelStyle}>Deductions ($)</label>
                    <input value={w4.deductions} onChange={e=>setW4(w=>({...w,deductions:e.target.value}))} placeholder="0" style={inputStyle}/>
                    <div style={{fontSize:10,color:'#8A9E8A',marginTop:4}}>If itemizing above standard deduction</div>
                  </div>
                  <div>
                    <label style={labelStyle}>Extra Withholding ($/period)</label>
                    <input value={w4.extraWithholding} onChange={e=>setW4(w=>({...w,extraWithholding:e.target.value}))} placeholder="0" style={inputStyle}/>
                    <div style={{fontSize:10,color:'#8A9E8A',marginTop:4}}>Additional amount to withhold each pay period</div>
                  </div>
                </div>
                <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',fontSize:12,color:'#2B2B2B'}}>
                  <input type="checkbox" checked={w4.multipleJobs} onChange={e=>setW4(w=>({...w,multipleJobs:e.target.checked}))} style={{accentColor:accent,width:14,height:14}}/>
                  Multiple jobs or spouse also works (check if applicable)
                </label>
                <div style={{padding:'10px 14px',background:'#F7F2EB',borderRadius:8,fontSize:11,color:'#6B7D6B',lineHeight:1.6}}>
                  By completing this form, I certify that the information provided is correct. I understand this determines my federal tax withholding.
                </div>
              </div>
            )}

            {/* STEP 3 - I-9 */}
            {step === 3 && (
              <div style={{display:'flex',flexDirection:'column',gap:16}}>
                <div style={{padding:'10px 14px',background:'rgba(160,57,43,0.05)',border:'1px solid rgba(160,57,43,0.15)',borderRadius:8,fontSize:12,color:'#A0392B'}}>
                  Federal law requires verification of identity and employment authorization. Please complete all fields accurately.
                </div>
                {sectionHead('Employee Information')}
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                  {[['Last Name','lastName'],['First Name','firstName'],['Date of Birth','dob'],['Social Security Number','ssn']].map(([label,key])=>(
                    <div key={key}>
                      <label style={labelStyle}>{label} *</label>
                      <input value={i9[key]||''} onChange={e=>setI9(v=>({...v,[key]:e.target.value}))}
                        type={key==='ssn'?'password':'text'}
                        placeholder={key==='ssn'?'XXX-XX-XXXX':key==='dob'?'MM/DD/YYYY':''}
                        style={inputStyle}/>
                    </div>
                  ))}
                </div>
                {sectionHead('Citizenship / Immigration Status')}
                <div style={{display:'flex',flexDirection:'column',gap:8}}>
                  {[
                    ['citizen','A citizen of the United States'],
                    ['noncitizen','A noncitizen national of the United States'],
                    ['resident','A lawful permanent resident'],
                    ['authorized','An alien authorized to work'],
                  ].map(([val,label])=>(
                    <label key={val} style={{display:'flex',alignItems:'center',gap:10,cursor:'pointer',padding:'10px 12px',border:`1px solid ${i9.citizenStatus===val?accent:'#EDE6DA'}`,borderRadius:8,background:i9.citizenStatus===val?accentBg:'#fff'}}>
                      <input type="radio" checked={i9.citizenStatus===val} onChange={()=>setI9(v=>({...v,citizenStatus:val}))} style={{accentColor:accent}}/>
                      <span style={{fontSize:12,color:'#2B2B2B'}}>{label}</span>
                    </label>
                  ))}
                </div>
                {sectionHead('Document Presented')}
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                  <div>
                    <label style={labelStyle}>Document Type *</label>
                    <select value={i9.docType} onChange={e=>setI9(v=>({...v,docType:e.target.value}))} style={inputStyle}>
                      <option value="passport">U.S. Passport</option>
                      <option value="passport_card">U.S. Passport Card</option>
                      <option value="drivers_license">Driver License + Social Security Card</option>
                      <option value="id_card">State ID + Social Security Card</option>
                      <option value="permanent_resident">Permanent Resident Card (I-551)</option>
                      <option value="employment_auth">Employment Authorization Document</option>
                    </select>
                  </div>
                  <div>
                    <label style={labelStyle}>Document Number *</label>
                    <input value={i9.docNumber} onChange={e=>setI9(v=>({...v,docNumber:e.target.value}))} style={inputStyle}/>
                  </div>
                  <div>
                    <label style={labelStyle}>Expiration Date</label>
                    <input value={i9.docExpiry} onChange={e=>setI9(v=>({...v,docExpiry:e.target.value}))} placeholder="MM/DD/YYYY" style={inputStyle}/>
                  </div>
                </div>
                <div style={{padding:'10px 14px',background:'#F7F2EB',borderRadius:8,fontSize:11,color:'#6B7D6B',lineHeight:1.6}}>
                  I attest, under penalty of perjury, that I am aware that federal law provides for imprisonment and/or fines for false statements or use of false documents in connection with completion of this form.
                </div>
              </div>
            )}

            {/* STEP 4 - Direct Deposit */}
            {step === 4 && (
              <div style={{display:'flex',flexDirection:'column',gap:16}}>
                <div style={{padding:'10px 14px',background:'rgba(74,124,89,0.06)',border:'1px solid rgba(74,124,89,0.2)',borderRadius:8,fontSize:12,color:'#4A7C59'}}>
                  Your paycheck will be deposited directly to your bank account. Payday is every other Friday.
                </div>
                {sectionHead('Primary Account')}
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                  <div style={{gridColumn:'1/-1'}}>
                    <label style={labelStyle}>Bank Name *</label>
                    <input value={directDeposit.bankName} onChange={e=>setDirectDeposit(d=>({...d,bankName:e.target.value}))} placeholder="e.g. Chase, Bank of America..." style={inputStyle}/>
                  </div>
                  <div>
                    <label style={labelStyle}>Routing Number * (9 digits)</label>
                    <input value={directDeposit.routingNumber} onChange={e=>setDirectDeposit(d=>({...d,routingNumber:e.target.value}))} placeholder="021000021" style={inputStyle}/>
                  </div>
                  <div>
                    <label style={labelStyle}>Account Number *</label>
                    <input value={directDeposit.accountNumber} onChange={e=>setDirectDeposit(d=>({...d,accountNumber:e.target.value}))} placeholder="Your account number" type="password" style={inputStyle}/>
                  </div>
                  <div>
                    <label style={labelStyle}>Account Type *</label>
                    <div style={{display:'flex',gap:8}}>
                      {['checking','savings'].map(type=>(
                        <button key={type} onClick={()=>setDirectDeposit(d=>({...d,accountType:type}))}
                          style={{flex:1,padding:'9px',border:`2px solid ${directDeposit.accountType===type?accent:'#EDE6DA'}`,borderRadius:6,background:directDeposit.accountType===type?accentBg:'#fff',color:directDeposit.accountType===type?accent:'#4A4A4A',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",textTransform:'capitalize'}}>
                          {type}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
                <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',fontSize:12,color:'#2B2B2B'}}>
                  <input type="checkbox" checked={directDeposit.split} onChange={e=>setDirectDeposit(d=>({...d,split:e.target.checked}))} style={{accentColor:accent,width:14,height:14}}/>
                  Split deposit into a second account
                </label>
                {directDeposit.split && (
                  <div style={{padding:'14px',background:'#F7F2EB',borderRadius:8,border:'1px solid #EDE6DA'}}>
                    {sectionHead('Second Account (Split)')}
                    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                      <div style={{gridColumn:'1/-1'}}>
                        <label style={labelStyle}>Amount to split ($)</label>
                        <input value={directDeposit.splitAmount} onChange={e=>setDirectDeposit(d=>({...d,splitAmount:e.target.value}))} placeholder="e.g. 200" style={inputStyle}/>
                      </div>
                      <div>
                        <label style={labelStyle}>Bank Name</label>
                        <input value={directDeposit.split2Bank} onChange={e=>setDirectDeposit(d=>({...d,split2Bank:e.target.value}))} style={inputStyle}/>
                      </div>
                      <div>
                        <label style={labelStyle}>Routing Number</label>
                        <input value={directDeposit.split2Routing} onChange={e=>setDirectDeposit(d=>({...d,split2Routing:e.target.value}))} style={inputStyle}/>
                      </div>
                      <div>
                        <label style={labelStyle}>Account Number</label>
                        <input value={directDeposit.split2Account} onChange={e=>setDirectDeposit(d=>({...d,split2Account:e.target.value}))} type="password" style={inputStyle}/>
                      </div>
                    </div>
                  </div>
                )}
                <div style={{padding:'10px 14px',background:'#F7F2EB',borderRadius:8,fontSize:11,color:'#6B7D6B',lineHeight:1.6}}>
                  By submitting this form, I authorize Demo Company Co. to initiate credit entries to the account indicated above and to initiate debit entries and adjustments for any credit entries made in error.
                </div>
              </div>
            )}

            {/* STEP 5 - Handbook */}
            {step === 5 && (
              <div style={{display:'flex',flexDirection:'column',gap:14}}>
                {handbookSigned && (
                  <div style={{display:'flex',alignItems:'center',gap:8,background:'rgba(74,124,89,0.1)',border:'1px solid #4A7C59',borderRadius:8,padding:'10px 14px'}}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="#4A7C59" strokeWidth="1.5"/><path d="M5 8l2 2 4-4" stroke="#4A7C59" strokeWidth="1.5" strokeLinecap="round"/></svg>
                    <span style={{fontSize:12,color:'#4A7C59',fontWeight:500}}>Signed by {handbookSig} - April 2, 2025</span>
                  </div>
                )}
                <div style={{background:'#F7F2EB',border:'1px solid #EDE6DA',borderRadius:8,padding:'16px',maxHeight:240,overflowY:'auto'}}>
                  <h3 style={{fontFamily:'Georgia,serif',fontSize:'1rem',color:'#2B2B2B',marginBottom:12}}>Employee Handbook - 2025 Edition</h3>
                  <p style={{fontSize:12,color:'#4A4A4A',lineHeight:1.8,marginBottom:10}}><strong>1. Welcome Statement</strong><br/>Demo Company Co. is committed to creating a respectful, inclusive, and productive workplace for all employees.</p>
                  <p style={{fontSize:12,color:'#4A4A4A',lineHeight:1.8,marginBottom:10}}><strong>2. Code of Conduct</strong><br/>All employees are expected to treat colleagues, clients, and partners with professionalism and respect at all times.</p>
                  <p style={{fontSize:12,color:'#4A4A4A',lineHeight:1.8,marginBottom:10}}><strong>3. Work Hours & Attendance</strong><br/>Standard hours are Monday through Friday, 8:00am to 4:30pm unless otherwise specified by your department manager.</p>
                  <p style={{fontSize:12,color:'#4A4A4A',lineHeight:1.8,marginBottom:10}}><strong>4. Time Off & PTO</strong><br/>Full-time employees accrue 1.25 days of PTO per month, totaling 15 days annually. PTO requests must be submitted at least 2 weeks in advance.</p>
                  <p style={{fontSize:12,color:'#4A4A4A',lineHeight:1.8,marginBottom:10}}><strong>5. Remote Work Policy</strong><br/>Remote work arrangements must be approved in writing by your direct supervisor and HR. Employees are expected to be available during core hours.</p>
                  <p style={{fontSize:12,color:'#4A4A4A',lineHeight:1.8}}><strong>6. Disciplinary Policy</strong><br/>Violations of company policy may result in verbal warning, written warning, suspension, or termination depending on severity.</p>
                </div>
                <div style={{border:'2px dashed #D9C3A3',borderRadius:8,padding:'16px',textAlign:'center'}}>
                  <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:8}}>Type your full legal name to electronically sign</div>
                  <input value={handbookSig} onChange={e=>setHandbookSig(e.target.value)} placeholder="Your full legal name"
                    style={{width:'100%',padding:'10px 14px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:14,fontFamily:'Georgia,serif',outline:'none',textAlign:'center',color:'#2B2B2B',boxSizing:'border-box'}}/>
                  <div style={{fontSize:10,color:'#8A9E8A',marginTop:8}}>By typing your name, you agree this constitutes a legally binding electronic signature.</div>
                </div>
              </div>
            )}

            {/* STEP 6 - Policies */}
            {step === 6 && (
              <div style={{display:'flex',flexDirection:'column',gap:10}}>
                <p style={{fontSize:13,color:'#6B7D6B',marginBottom:4}}>Please read and acknowledge each policy below. All policies must be acknowledged to proceed.</p>
                {[
                  {key:'attendance', title:'Attendance & Punctuality Policy', desc:'I understand the attendance requirements and the process for reporting absences or tardiness.'},
                  {key:'pto',        title:'PTO & Time Off Policy',           desc:'I understand how PTO accrues, how to request time off, and the approval process.'},
                  {key:'conduct',    title:'Code of Conduct',                  desc:'I agree to maintain professional conduct and treat all colleagues with respect.'},
                  {key:'safety',     title:'Workplace Safety Policy',          desc:'I understand my responsibilities regarding workplace safety and hazard reporting.'},
                  {key:'data',       title:'Data Privacy & Confidentiality',   desc:'I agree to protect company and client data in accordance with company policy.'},
                ].map(policy=>(
                  <div key={policy.key} onClick={()=>setPolicyAcks(p=>({...p,[policy.key]:!p[policy.key]}))}
                    style={{display:'flex',alignItems:'flex-start',gap:12,padding:'14px',border:`1px solid ${policyAcks[policy.key]?'#4A7C59':'#EDE6DA'}`,borderRadius:8,background:policyAcks[policy.key]?'rgba(74,124,89,0.06)':'#fff',cursor:'pointer',transition:'all 0.15s'}}>
                    <div style={{width:20,height:20,borderRadius:4,border:`1.5px solid ${policyAcks[policy.key]?'#4A7C59':'#D9C3A3'}`,background:policyAcks[policy.key]?'#4A7C59':'#fff',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,marginTop:1}}>
                      {policyAcks[policy.key] && <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5l2 2 4-4" stroke="#fff" strokeWidth="1.5" strokeLinecap="round"/></svg>}
                    </div>
                    <div>
                      <div style={{fontSize:13,fontWeight:600,color:'#2B2B2B',marginBottom:3}}>{policy.title}</div>
                      <div style={{fontSize:11,color:'#6B7D6B',lineHeight:1.5}}>{policy.desc}</div>
                    </div>
                  </div>
                ))}
                <div style={{padding:'10px 14px',background:'#F7F2EB',borderRadius:8,fontSize:11,color:'#6B7D6B',marginTop:4}}>
                  {Object.values(policyAcks).filter(v=>v).length} of 5 policies acknowledged
                  {Object.values(policyAcks).every(v=>v) && <span style={{color:'#4A7C59',fontWeight:600,marginLeft:8}}>All acknowledged!</span>}
                </div>
              </div>
            )}

            {/* STEP 7 - Complete */}
            {step === 7 && (
              <div style={{textAlign:'center',padding:'2rem 1rem'}}>
                <div style={{fontSize:48,marginBottom:16}}>🎉</div>
                <h2 style={{fontFamily:'Georgia,serif',fontSize:'1.6rem',color:'#2B2B2B',marginBottom:8}}>You're all set, Jamie!</h2>
                <p style={{fontSize:13,color:'#6B7D6B',lineHeight:1.7,maxWidth:400,margin:'0 auto 24px'}}>Your onboarding is complete! All documents have been submitted and your manager has been notified. Welcome to the team!</p>
                <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:10,maxWidth:440,margin:'0 auto 24px'}}>
                  {[['8','Steps Done'],['3','Forms Filed'],['1','Handbook Signed'],['5','Policies Acked']].map(([v,l])=>(
                    <div key={l} style={{background:'#F7F2EB',border:'1px solid #EDE6DA',borderRadius:8,padding:'12px 8px'}}>
                      <div style={{fontFamily:'Georgia,serif',fontSize:'1.3rem',color:accent,fontWeight:600}}>{v}</div>
                      <div style={{fontSize:9,color:'#6B7D6B',textTransform:'uppercase',letterSpacing:'0.08em',marginTop:2,lineHeight:1.3}}>{l}</div>
                    </div>
                  ))}
                </div>
                <div style={{display:'flex',flexDirection:'column',gap:8,maxWidth:340,margin:'0 auto 20px'}}>
                  {[
                    {icon:'🏛️',label:'W-4 submitted to payroll'},
                    {icon:'📋',label:'I-9 on file with HR'},
                    {icon:'🏦',label:'Direct deposit configured'},
                    {icon:'📖',label:'Handbook signed & saved'},
                    {icon:'✅',label:'All policies acknowledged'},
                  ].map(item=>(
                    <div key={item.label} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 12px',background:'rgba(74,124,89,0.06)',border:'1px solid rgba(74,124,89,0.15)',borderRadius:6}}>
                      <span style={{fontSize:14}}>{item.icon}</span>
                      <span style={{fontSize:12,color:'#4A7C59',fontWeight:500}}>{item.label}</span>
                    </div>
                  ))}
                </div>
                <button style={{padding:'10px 24px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                  Go to My Dashboard
                </button>
              </div>
            )}
          </div>

          {/* Nav buttons */}
          {step < 7 && (
            <div style={{display:'flex',justifyContent:'space-between',padding:'14px 20px',borderTop:'1px solid #EDE6DA',background:'#fff',flexShrink:0}}>
              <button onClick={()=>setStep(s=>s-1)} style={{visibility:step===0?'hidden':'visible',padding:'8px 18px',border:'1px solid #EDE6DA',borderRadius:6,background:'#fff',fontSize:12,fontWeight:600,color:'#4A4A4A',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                Back
              </button>
              <button onClick={handleNext} style={{padding:'8px 24px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                {step === 6 ? 'Complete Onboarding' : 'Continue'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
